import { Button, Card, Form } from '../../../ui';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Spinner } from '../../../ui';
import { Helmet } from 'react-helmet';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useServiceErrorHandler } from '../../../../hooks/useServiceErrorHandler';
import * as accountService from '../../../../services/account';

type PageParams = {
  code: string;
};

const EmailVerificationPage: FunctionComponent = () => {
  const history = useHistory();
  const handleServiceError = useServiceErrorHandler();
  let { code } = useParams<PageParams>();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) {
      history.push('/');
      return;
    }

    let cancelled = false;
    accountService
      .verifyEmail(code)
      .then(verified => {
        if (cancelled) return;
        if (verified) {
          history.push('/');
        } else {
          setLoading(false);
        }
      })
      .catch(error =>
        handleServiceError(error, () => {
          if (!cancelled) setLoading(false);
        })
      );

    return () => {
      cancelled = true;
    };
  }, [code, history, handleServiceError]);

  return (
    <div>
      <Helmet>
        <title>Email verification</title>
      </Helmet>

      <Card>
        <Card.Body>
          <h1 className="flex items-center justify-center gap-2 text-2xl font-bold text-gray-900 text-center mb-6">
            {(() => {
              if (loading) {
                return (
                  <>
                    <Spinner animation="grow"></Spinner> Verifying email...
                  </>
                );
              }
              return 'Oops, something went wrong';
            })()}
          </h1>
          <Form noValidate>
            {(() => {
              if (!loading) {
                return (
                  <Button className="mt-4 w-full flex" as={Link} to={'/'}>
                    Back
                  </Button>
                );
              }
            })()}
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default EmailVerificationPage;
